<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed, useAttrs } from 'vue'
import FlagIcon from 'vue3-flag-icons'
import { EuroIcon, GlobeIcon } from 'lucide-vue-next'

const props = defineProps({
  size: {
    type: Number,
    default: 6,
  },
  ring: {
    type: Boolean,
    default: false,
  },
  collapseOnMobile: {
    type: Boolean,
    default: false,
  },
})

const code = computed(() => usePage().props.session?.currency?.code ?? usePage().props.tenant.currency.code)

const attrs = useAttrs()

const tailwindSizeToPx = computed(() => {
  return props.size * 4
})

const dynamicComponent = computed({
  get: function() {
    let flagIconProps = {
      size: tailwindSizeToPx.value,
      circle: true,
    }

    switch (code.value) {
      case 'AUD':
        return {
          component: FlagIcon,
          props: { ...flagIconProps, code: 'au' },
        }
      case 'CAD':
        return {
          component: FlagIcon,
          props: { ...flagIconProps, code: 'ca' },
        }
      case 'CHF':
        return {
          component: FlagIcon,
          props: { ...flagIconProps, code: 'ch' },
        }
      case 'EUR':
        return {
          component: EuroIcon,
          props: { class: 'size-full p-1 bg-blue-600 text-white' },
        }
      case 'GBP':
        return {
          component: FlagIcon,
          props: { ...flagIconProps, code: 'gb' },
        }
      case 'NZD':
        return {
          component: FlagIcon,
          props: { ...flagIconProps, code: 'nz' },
        }
      case 'USD':
        return {
          component: FlagIcon,
          props: { ...flagIconProps, code: 'us' },
        }
      default:
        return {
          component: GlobeIcon,
          props: { class: 'size-full p-1 bg-blue-600 text-white' },
        }
    }
  },
})
</script>

<template>
  <div v-bind="attrs"
       class="w-fit px-2 py-1 text-xs group flex items-center gap-y-1 gap-x-2 rounded"
  >
    <div :class="{
        'overflow-hidden group-hover:ring-4 group-hover:ring-offset-1 group-hover:ring-gray-600/30': ring,
        [`rounded-full overflow-hidden grid justify-items-center size-${size}`]: true
      }">
      <component :is="dynamicComponent.component" v-bind="dynamicComponent.props" />
    </div>

    <span :class="{
      'hidden sm:inline': collapseOnMobile,
      'font-normal': true
    }">
      {{ code }}
    </span>
  </div>
</template>
